import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const bankfields = {
  _id: '',
  bankName: '',
  altKeyBase: '',
  groupCode: '',
  accountNumber: '',
  routingNumber: '',
  bankAddress: '',
  location: '',
  bankCode: '',
  isInvAcct: '',
  isReconAcct: '',
  isSubledger: '',
  line: '',
  isAlwaysPrint: '',
  isOD: '',
  isCash: '',
  isSweepAcct: '',
  isDepositSlipEnabled: '',
  isBaseAmount: '',
  hideFromSharedList: '',
  hideOnReports: '',
};

const bankWithCollateralfields = {
  _id: '',
  bankName: '',
  location: '',
  altKeyBase: '',
  groupCode: '',
  accountNumber: '',
  routingNumber: '',
  bankAddress: '',
  bankCode: '',
  isInvAcct: '',
  isReconAcct: '',
  isSubledger: '',
  line: '',
  isAlwaysPrint: '',
  isOD: '',
  isCash: '',
  isSweepAcct: '',
  isBaseAmount: '',
  isDepositSlipEnabled: '',
  hideFromSharedList: '',
  hideOnReports: '',
  bankCollateralRecord: {
    _id: '',
    bankName: '',
    fiscalYear: '',
    // asOfDate: '',
    bankIntials: '',
    // cashBalance: '',
    pledgesLeft: '',
    details: {
      asOfDate: '',
      // description: '',
      // amount: '',
      loc: '',
      pledges: '',
      sweep: '',
      fdic: '',
    },
  },
};

export const bank = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
  }),
  mutations: {
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
  },
  actions: {
    async loadBanks({ commit, dispatch }, {
      criteria, baseCrudKey,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query banks($criteria: BankCriteriaType) {
                  banks(criteria: $criteria) {
                    ${fieldsToGqlString(bankfields)},
                  }
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data && results.data.banks) {
          const banks = results.data ? results.data.banks || [] : [];
          commit('base/crud/setItems', [baseCrudKey, banks], { root: true });
          return banks;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the banks list.', { root: true });
      }
      return [];
    },
    async loadBankWithCollateralList({ commit, dispatch }, {
      criteria, baseCrudKey,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query bankWithCollateralList($criteria: BankCriteriaType) {
                  bankWithCollateralList(criteria: $criteria) {
                    ${fieldsToGqlString(bankWithCollateralfields)},
                  }
                }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data && results.data.bankWithCollateralList) {
          const bankWithCollateralList = results.data
            ? results.data.bankWithCollateralList || [] : [];
          // Tag hidden banks with blue highlight class for CRUDRow
          const taggedList = bankWithCollateralList.map((bankItem) => {
            if (bankItem.hideFromSharedList) {
              return { ...bankItem, crudRowCssAppend: ['hidden-bank-highlight'] };
            }
            return bankItem;
          });
          commit('base/crud/setItems', [baseCrudKey, taggedList], { root: true });
          return taggedList;
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was problem loading the bank list.', { root: true });
      }
      return [];
    },
    async upsertBank({ dispatch, rootGetters, commit }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertBank ($item: BankInputType!)  {
            upsertBank(upsert: $item) {
              ${fieldsToGqlString(bankfields)},
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const banksStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newBank = results.data.upsertBank;
        const newList = mergeByIdNewAtTop(banksStateData || [], newBank);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Bank', { root: true });
      }
    },
    async deleteSharedBank({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteSharedBank($_id: ID!)  {
            deleteSharedBank(_id: $_id) {
                  _id
                }
              }`,
          variables: { _id: item._id },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteSharedBank._id;
        if (delId) {
          const sharedBankList = rootGetters['base/crud/items'](baseCrudKey);
          const updatedData = sharedBankList.filter((d) => d._id !== delId);
          commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
          commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
          dispatch('flashSuccess', 'Bank got deleted Successfully!', { root: true });
        } else {
          dispatch('flashError', 'This Bank is currently being used!', { root: true });
        }
        return delId;
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the Bank!', { root: true });
      }
      return null;
    },
  },
};

export default bank;
